var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('gift-progress-submenu',{attrs:{"steps-number":_vm.stepsNumber,"step":_vm.step,"title":_vm.title,"previous-step":_vm.previousStep,"next-step":_vm.nextStep}}),_c('transition',[_c('section',[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }